if (!customElements.get('miix-reel-card')) {
  customElements.define(
    'miix-reel-card',
    class MiixReelCard extends HTMLElement {
      connectedCallback() {
        this.videoElement = this.querySelector('video-element');
        if (!this.videoElement) return;

        this.onVideoPlay = this.onVideoPlay.bind(this);
        this.onVideoPause = this.onVideoPause.bind(this);
        this.onPosterClick = this.onPosterClick.bind(this);

        this.videoElement.addEventListener('video:play', this.onVideoPlay);
        this.videoElement.addEventListener('video:pause', this.onVideoPause);

        const poster = this.videoElement.querySelector('[id^="DeferredPoster-"]');
        if (poster) {
          poster.addEventListener('click', this.onPosterClick);
        }
      }

      disconnectedCallback() {
        if (!this.videoElement) return;
        this.videoElement.removeEventListener('video:play', this.onVideoPlay);
        this.videoElement.removeEventListener('video:pause', this.onVideoPause);
      }

      get nativeVideo() {
        return this.videoElement?.querySelector('video');
      }

      unmute() {
        const video = this.nativeVideo;
        if (!video) return;
        video.muted = false;
        video.removeAttribute('muted');
        try {
          video.volume = 1;
        } catch (e) {
          // ignore
        }
      }

      pauseOtherReels() {
        document.querySelectorAll('miix-reel-card').forEach((card) => {
          if (card === this) return;
          const other = card.querySelector('video-element');
          if (other?.playing) other.pause();
        });
      }

      onPosterClick() {
        // User gesture: unmute on the same click that starts playback
        requestAnimationFrame(() => {
          if (this.videoElement?.playing) {
            this.unmute();
          }
        });
      }

      onVideoPlay() {
        this.unmute();
        this.pauseOtherReels();
        this.classList.add('is-playing');
      }

      onVideoPause() {
        this.classList.remove('is-playing');
      }
    }
  );
}
